import { createSelector } from '@reduxjs/toolkit'
import { sortCheckpointableEntities } from '../../../helpers/sortCheckpointableEntities'
import {
  getCompletedPhaseItemsIds,
  getCompletedAssignmentsIds,
} from '../../getters/entities/taskIds'
import { NormalizedTask } from '../types'
import { selectNormalizedTasks } from './normalizedTasks'

const selectCompletedAssignmentIds = createSelector(
  [getCompletedAssignmentsIds],
  (completedAssignmentIds) => completedAssignmentIds || []
)

const selectCompletedPhaseItemIds = createSelector(
  [getCompletedPhaseItemsIds],
  (completedPhaseItemIds) => completedPhaseItemIds || []
)

export const selectCompletedTasks = createSelector(
  [
    selectNormalizedTasks,
    selectCompletedAssignmentIds,
    selectCompletedPhaseItemIds,
  ],
  (normalizedTasks, completedAssignmentIds, completedPhaseItemIds) => {
    const phaseItems = completedPhaseItemIds.map((id) =>
      normalizedTasks.find(
        (task) => task.id === id && task.entityType === 'phase_item'
      )
    )

    const assignments = completedAssignmentIds.map((id) =>
      normalizedTasks.find(
        (approval) => approval.id === id && approval.entityType === 'assignment'
      )
    )

    return sortCheckpointableEntities(
      [...phaseItems, ...assignments].filter(
        (task): task is NormalizedTask => task !== undefined
      )
    )
  }
)
